<template>
  <v-autocomplete
      v-model="search"
      :items="searchItems"
      item-value="id"
      item-text="name"
      :placeholder="placeholder"
      :label="label"
      clearable
      outlined
      dense
      class="mr-2"
      @change="onChangeHandler"
      :rules="requiredFieldRule"
  />
</template>

<script>
export default {
  name: "GFilterAutocomplete",
  data() {
    return {
      search: '',
      requiredFieldRule: [
        v => {
          if (!v && this.validation) {
            return 'This field is required';
          } else {
            return true;
          }
        },
      ],
    }
  },
  props: {
    searchItems: {
      type: Array,
      default: function () {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: function () {
        return '';
      }
    },
    label: {
      type: String,
      default: function () {
        return '';
      }
    },
    validation: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
  },
  methods: {
    onChangeHandler() {
      const arg = this.search ? this.search : '';
      this.$emit('onChangeHandler', arg);
    }
  }
}
</script>

<style scoped>

</style>